import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { USER_ADD, USER_EDIT, USER_GENERATE } from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import { CONSTANT, LOADING_KEY } from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-b221',
  templateUrl: './b221.component.html',
  styleUrls: ['./b221.component.scss', '../platform.component.scss'],
})

/**
 * ユーザ登録(B221)
 * ユーザ登録確認(B222)
 */
export class B221Component extends PlatformComponent {
  // 画面.入力フォーム
  b221InputForm: FormGroup = this.formBuilder.group({
    member_id: CONSTANT.EMPTY_STRING,
    // 部局名／事業部名
    department_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'department_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 課室名／部署名
    division_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'division_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 役職
    jobposition_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'jobposition_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 氏名
    full_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'full_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 電話番号
    tel: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'tel',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // emailアドレス
    email: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'email',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // emailアドレス確認
    email_confirmation: this.formBuilder.control(CONSTANT.EMPTY_STRING),
    // メルマガ受信設定
    mailmagazine_flg: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
      this.validator.CheckValidator(
         'user',
         'mailmagazine_flg',
         INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
      ),
      ],
    }),
  });

  // ユーザIDを格納
  user_id: string = this.route.snapshot.queryParams.user_id;

  // 確認画面表示フラグ(true=ユーザ登録確認(B222)),false=ユーザ登録(B221))
  confirmationFlag: boolean = false;

  // emailアドレス格納先(編集時の確認表示用)
  editDisplayEmail: string;

  //メルマガ受信設定編集時に使用
  flg_true = 1
  flg_false = 0

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlをユーザ登録(B221)に変更する
    this.router.navigate(['pages/platform/b221/' + this.inputType], {
      queryParams: {
        screenId: 'b221',
        user_id: this.user_id,
      },
    });
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogin();

    // 辞書値リストを取得
    this.getSpecCodeList(123);

    // 編集初期表示
    this.setEditInitialData();
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });

  }

  ngAfterViewInit(): void {
    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規の場合
      // emailアドレス確認チェックを実施
      this.checkConfirmationEmail();
    }
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(USER_GENERATE);

    // ユーザ詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(USER_GENERATE, this.user_id ? this.user_id : '-1', false)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          return;
        }
        if(!this.decisionPerspective(response.body.member_id)
          && !this.decisionSecretariat()
        ){
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.b221InputForm,
          response.body
        );

        // emailアドレス格納先(編集時の確認表示用)にセット
        this.editDisplayEmail = response.body.email;

        // eメールアドレスの初期値をセット
        this.b221InputForm
          .get('email_confirmation')
          .setValue(response.body.email);

        // eメールアドレスの編集不可
        this.b221InputForm.get('email').disable();

        // eメールアドレス確認の編集不可
        this.b221InputForm.get('email_confirmation').disable();

        //メルマガ受信設定を配列で渡す
        if(response.body.mailmagazine_flg == "1"){
          this.b221InputForm.get('mailmagazine_flg').setValue([response.body.mailmagazine_flg]);
        }else{
          this.b221InputForm.get('mailmagazine_flg').setValue([]);
        }



        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, USER_GENERATE);
      });
  }

  /**
   * emailアドレス確認チェック
   * @param input true:画面入力 false:初回
   */
  public checkConfirmationEmail(input?: boolean): void {
    // 画面入力されたか否か
    if (input) {
      // 画面入力された場合

      // 変更検知をtrueにする(エラーメッセージ表示有無フラグ)
      this.b221InputForm.get('email_confirmation').markAsDirty();
    }

    // 画面.入力フォーム.パスワード確認を取得
    const emailConfirmation =
      this.b221InputForm.get('email_confirmation').value;

    // 画面.入力フォーム.パスワード確認が未入力か否か
    if (!emailConfirmation) {
      // 未入力の場合

      // 必須項目エラー
      this.b221InputForm.controls['email_confirmation'].setErrors({
        message: '必須項目です。必ず入力してください。',
      });

      return;
    }

    // 画面.入力フォーム.パスワード確認がパスワードと同様か確認
    if (emailConfirmation != this.b221InputForm.get('email').value) {
      // 同様でない場合
      this.b221InputForm.controls['email_confirmation'].setErrors({
        message: 'emailアドレスの値と一致していません',
      });
      return;
    }

    // エラーメッセージを空にする
    this.b221InputForm.controls['email_confirmation'].setErrors(null);

    return;
  }

  /**
   * ユーザ登録(B221)を表示する
   */
  public moveB221(): void {
    // ユーザ登録(B211)へ遷移
    this.router.navigate(
      ['pages/platform/b221/' + this.route.snapshot.params.inputType],
      {
        queryParams: {
          screenId: 'b221',
          user_id: this.user_id,
        },
      }
    );

    // ユーザ登録(B221)を表示する
    this.confirmationFlag = false;
  }

  /**
   *ユーザ登録確認(B222)を表示する
   */
  public moveB222(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let b221InputForm: any = JSON.parse(
      JSON.stringify(this.b221InputForm.value)
    );

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult('user', b221InputForm),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // ユーザ登録確認(B222)へ遷移
      this.router.navigate(
        ['pages/platform/b221/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'b222',
            user_id: this.user_id,
          },
        }
      );

      // ユーザ登録確認(B222)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * ユーザ登録完了(B223)へ遷移する
   */
  public moveB223(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let b221InputForm: any = JSON.parse(
      JSON.stringify(this.b221InputForm.value)
    );

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    //登録時にnumber型でメルマガ受信設定を渡す
    if(b221InputForm.mailmagazine_flg == "1"){
      b221InputForm.mailmagazine_flg = this.flg_true;
    }else{
      b221InputForm.mailmagazine_flg = this.flg_false;
    }

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // ログインユーザ情報の会員IDをセット
      b221InputForm.member_id = this.loginUser.member_id;

      // ユーザ登録を実施
      this.dbOperationService
        .insertData(USER_ADD, b221InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // ユーザ登録完了(B223)へ遷移
            this.router.navigate(['pages/platform/b223']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // ユーザ登録(B221)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集の場合

      // ユーザ更新を実施
      this.dbOperationService
        .updateData(USER_EDIT, this.user_id, b221InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // ログインユーザーが更新ユーザーだった場合
            if(this.user_id == this.loginUser.user_id){
              // ユーザー情報取得後、ユーザ登録完了(B223)へ遷移
              this.setLoginUserInfo();
            } else {
              // ユーザ登録完了(B223)へ遷移
              this.router.navigate(['pages/platform/b223']);
            }
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // ユーザ登録(B221)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }

  /**
   * ログインユーザ情報取得後、ユーザ登録完了(B223)へ遷移する
   */
  public setLoginUserInfo(): void {
    // ログインユーザー情報を再取得
    this.loginService.getLoginUser().subscribe((response) => {

      // ログインユーザ情報がユーザマスタに存在するか否か
      if (this.commonService.checkNoneResponse(response)) {
        // ユーザマスタに存在しない場合

        // 不正なユーザの為、ログアウト処理
        this.loginService.logout(MESSAGE_CODE.E90000);

        // 処理を終了
        return;
      } else {
        // セッションにユーザ情報を格納
        window.sessionStorage.setItem(
          SESSION_KEY.loginUserInformation,
          JSON.stringify(response.body[0])
        );

        // ユーザ登録完了(B223)へ遷移
        this.router.navigate(['pages/platform/b223']);
      }
    });
  }
}
